import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BlastTable from '../../components/tables/blast/BlastTable';
import { useGame } from '../../context/GameContext';

export const BlastView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { startNewGame, gameState } = useGame();

  React.useEffect(() => {
    if (location.state?.config) {
      startNewGame(location.state.config);
    }
  }, [location.state, startNewGame]);

  if (!gameState?.gameConfig) {
    navigate('/blast-config');
    return null;
  }

  return <BlastTable />;
};

export default BlastView;
